exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".floating-select-infinite-no-options-message {\n  display: flex;\n  line-height: 32px;\n  justify-content: center; }\n\n.floating-select-infinite-menu-list.no-options {\n  overflow: auto !important; }\n\n.floating-select-infinite-menu-option {\n  line-height: 32px;\n  cursor: pointer; }\n  .floating-select-infinite-menu-option:hover {\n    background-color: #EFF2F4 !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/postcss-loader/lib??ref--3-2!../node_modules/sass-loader/lib/loader.js!../node_modules/@opuscapita/react-floating-select/lib/es/floating-select-infinite/floating-select-infinite.scss
// module id = 526
// module chunks = 0